import React from "react";
import AppConfig from "../AppConfig";
import { Attendance } from "./Attendance/Attendance";

export default function Home() {
  return (
      <Attendance />
  );
}
